<template>
  <step-manager v-if="currentStep"
                :class="$setClasses">
    <nxt-core-input-fields :class="$vClass('fields')"
                           :core-fields="coreFields"
                           :custom-fields="customFields"
                           :current-store="currentStore"
                           :init-test-validate-form="false"
                           input-container="nxt-core-input-container"/>
  </step-manager>
</template>

<script>
import { mapState } from 'pinia';
import { usePartnerStore } from '../../store/partnerStore.ts';

export default {
  name: 'MultiStepForm',
  nameClassStyle: 'multi-step-form',
  data() {
    return {
      customFields: ['address', 'estimate', 'estimation-simulator', 'volume', 'meeting', 'card', 'rooms', 'minarm-rights',
        'inventory', 'confirm', 'type-meeting'],
      coreFields: ['html-content', 'script-content'],
    };
  },
  computed: {
    ...mapState(usePartnerStore, ['currentStep']),
    currentStore() {
      return usePartnerStore();
    },
  },
};
</script>
